'use client';

import NextError from 'next/error';

/** 保留 Next.js 默认 404 内容和布局，仅让文字继承全站鸿蒙字体。 */
export function FireflyNotFound() {
  return (
    <div className="firefly-not-found-page">
      <NextError statusCode={404} />
    </div>
  );
}
